import { Link } from "react-router-dom";

const LIT = [0, 2, 4, 6, 8];

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <span className={`relative grid grid-cols-3 gap-[3px] rounded-[10px] bg-primary p-[6px] ${className}`}>
    {Array.from({ length: 9 }).map((_, i) => (
      <span key={i} className={`rounded-[2px] ${LIT.includes(i) ? "bg-white" : "bg-white/35"} ${i === 4 ? "!bg-accent dark:!bg-white" : ""}`} />
    ))}
  </span>
);

export const Logo = ({ to = "/" }) => (
  <Link to={to} className="flex items-center gap-2.5 shrink-0" data-testid="header-logo-link">
    <LogoMark />
    <span className="font-display text-xl font-extrabold tracking-tight">
      HubPilot<span className="text-accent dark:text-primary">.au</span>
    </span>
  </Link>
);
